import React, { useEffect, useState } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import { price2StringPrice } from "utils/priceformatter";
import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";
import { useClientPayments } from "Context/ClientPayments";

const createTableRows = (clientPayments) => {
  return clientPayments?.map((cp) => {
    return [
      cp.Id,
      price2StringPrice(cp.Amount === null ? 0 : cp.Amount),
      cp.ClientId,
      cp.PaymentAccount,
      cp.PaymentType,
      cp.FileId,
      getParseStatusLabelById(cp.ParseStatus),
      cutStrAtAndAddDots(cp.ParseMessage, 45),
      getSystemStatusLabelById(cp.SystemStatus),
      cp.CreateTime,
    ];
  });
};

export default function ClientPaymentTable() {
  const location = useLocation();
  const { clientPayments, getClientPayments } = useClientPayments();
  const [queryFrom, setQueryFrom] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (location) {
      const queryParams = new URLSearchParams(location.search);
      const from = queryParams.get("from");
      if (from) {
        setQueryFrom(from);
      }
    }
  }, [location]);

  useEffect(() => {
    const rows = createTableRows(clientPayments);
    setRows(rows);
  }, [clientPayments]);

  useEffect(() => {
    getClientPayments();
  }, []);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Belopp",
      options: {
        filter: false,
      },
    },

    {
      name: "Klient ID",
      options: {
        // filter: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clients/${rows[dataIndex][2]}`}>
              {rows[dataIndex][2]}
            </Link>
          );
        },
      },
    },
    {
      name: "Konto",
      options: {
        filter: false,
      },
    },
    {
      name: "Kontotyp",
      options: {
        filter: false,
      },
    },
    {
      name: "Fil ID",
      options: {
        filter: true,
        empty: false,
        filterList: queryFrom === "balanceSummary" ? [null] : [],
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/files/${rows[dataIndex][5]}`}>
              {rows[dataIndex][5]}
            </Link>
          );
        },
      },
    },
    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
      },
    },
  ];

  const options = {
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    downloadOptions: {
      separator: ";",
      filename: "all_clients.csv",
    },

    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
